import type { i18n } from 'i18next';
import * as i18nSyncEn from './common/i18n.json';

/**
 * Initializes the i18n instance with the resource bundle.
 *
 * @param i18nInstance - The i18n instance used to add the resource bundle
 */
export function initI18n(i18nInstance: i18n): void {
    i18nInstance.addResourceBundle(i18nInstance.language, 'translation', i18nSyncEn);
}
